import styled, { css } from 'styled-components';

export const WithDropdownWrapper = styled.div`
  ${props =>
    props.disabled &&
    css`
      cursor: not-allowed;
    `}
`;
